/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef, new-cap */
// Komentar di atas memberi tahu linter untuk tidak komplain tentang variabel global L dan windyInit

import LandmarkSvc from '@/services/LandmarkSvc';
import SeriesSvc from '@/services/SeriesSvc';
import { convertDecimalToDMS } from '@/views/map/utils/coordinates';
import markerOnline from '@/assets/images/map/online-marker.svg';
import headingOnline from '@/assets/images/map/online-heading.svg';
import headingOffline from '@/assets/images/map/offline-heading.svg';
import headingNoGps from '@/assets/images/map/no-gps-heading.svg';
import headingNoSensor from '@/assets/images/map/no-sensor-heading.svg';
import { getRpmTypeLabel } from '@/util/fms-summary';
import { formatDateTime } from '@/util/date';
import { hourWindowLabel } from '@/util/trailData';
import {
  buildIconConfig,
  getMapIconStyle,
  setMapIconStyle as persistMapIconStyle,
  getMapIconScale,
  setMapIconScale as persistMapIconScale,
  scaleIconSize,
  MARKER_ICON_BASE_SIZE,
  HEADING_ICON_BASE_SIZE,
} from '@/util/shipIcons';
import detailedIconSample from '@/assets/images/map/tug-boat-icon.svg';
import simpleIconSample from '@/assets/images/map/online-ship.svg';
import {
  buildDetailGroups,
  buildTrailStats,
  statusLabel as shipStatusLabel,
  statusColor as shipStatusColor,
  formatDataTime as splitDataTime,
  TRAIL_DAY_OPTIONS,
  describeLocation,
} from '@/util/vesselDetail';

// Helper function to convert minutes to HH:MM:SS format
function formatRunningMinutes(minutes) {
  // eslint-disable-next-line no-restricted-globals
  if (minutes === null || minutes === undefined || isNaN(minutes)) {
    return '-';
  }
  const totalSeconds = Math.floor(minutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

function convertKmhToKnots(speedKmh) {
  if (speedKmh === null || speedKmh === undefined || Number.isNaN(Number(speedKmh))) {
    return null;
  }
  return Number(speedKmh) / 1.852;
}

class MapService {
  constructor(vueComponent) {
    /**
     * @type {import('vue').default}
     * Referensi ke instance komponen Vue.
     * Dibutuhkan untuk mengakses props (ships), data, methods (handleClick), dan $store/$router.
     */
    this.vm = vueComponent;

    // Expose Vue instance to window for popup button click handler
    window.mapServiceVm = vueComponent;

    // State internal layanan
    this.map = null;
    this.shipsLayerGroups = {};
    this.trail = {};
    this.dotTrail = {};
    this.trailCheckboxStatus = {};
    this.trailDays = {};
    // rentang yang dipakai waktu trail tiap kapal difetch, buat deteksi filter tanggal ganti
    this.trailRangeKey = {};
    // true selama kontrol ukur jarak aktif; picker cuaca Windy nahan diri selama ini
    this.measuring = false;
    // cache lokal detail titik dot trail - sengaja gak di Vuex biar commit gak trigger rebuild map & nutup popup
    this.pointDetail = {};
    this.openPopupMassId = null;
    this.currentPopupPage = 1;
    this.currentDotTrailPopupPage = 1;
    this.totalPopupPages = 3;
    this.landmarksVisible = false;
    this.landmarks = [];
    this.landmarksLayer = null;
    this.landmarkIcon = null;
    this.landmarkFetchTimeout = null;
    this.lastLandmarkBoundsKey = null;
    this.lastLandmarkBounds = null;
    this.clusterZoomThreshold = 8;
    this.baseLayers = {};
    this.activeBaseLayerKey = null;
    this.activeBaseLayer = null;
    this.mapSettingsPanel = null;
    this.resizeObserver = null;
    this.resizeRaf = null;
    this.timezoneLayer = null;
    this.timezoneVisible = false;
    this.timezoneData = null;
    this.timezoneRenderer = null;
  }

  // --- Inisialisasi dan Penghancuran Peta ---

  initializeDefaultMap(elementId) {
    if (this.map || !document.getElementById(elementId)) return;

    const map = L.map(elementId).setView([-6.2, 106.816666], 13, {
      animate: true,
      pan: {
        duration: 1,
      },
    });
    map.setMinZoom(5);
    map.setMaxZoom(19);

    const googleLayer = L.tileLayer('https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&gl=id&hl=id', {
      maxZoom: 19,
      attribution: 'Map data © Google Maps',
    });
    const googleLayerSat = L.tileLayer('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&gl=id&hl=id', {
      maxZoom: 19,
      attribution: 'Map data © Google Maps',
    });
    const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors',
    });

    this.map = map;
    this.baseLayers = {
      satellite: googleLayerSat,
      vectorColor: googleLayer,
      vectorWhite: osmLayer,
    };
    const storedKey = localStorage.getItem('activeBaseLayer') || 'satellite';
    this.setBaseLayer(this.baseLayers[storedKey] ? storedKey : 'satellite');

    this.attachCommonMapBehaviour(elementId);
  }

  // Setup yang sama buat peta default & peta Windy. Dipanggil sesudah `this.map`
  // keisi. Base layer sengaja gak di sini — itu cuma punya jalur default, di Windy
  // base map-nya punya Windy.
  attachCommonMapBehaviour(elementId) {
    const { map } = this;

    L.control.polylineMeasure(this.getPolylineMeasureOptions()).addTo(map);

    // `:toggle` fire pas kontrolnya dinyalain/dimatiin — `:start` baru fire pas
    // titik pertama digambar, kelewat telat buat nahan picker di klik yang sama.
    map.on('polylinemeasure:toggle', (e) => { this.measuring = !!e.status; });

    // Menghubungkan event peta kembali ke komponen Vue
    map.on('polylinemeasure:start', () => this.vm.handlePolylineStart());
    map.on('polylinemeasure:change', (e) => this.vm.handlePolylineChange(e));
    map.on('polylinemeasure:clear', () => this.vm.handlePolylineClear());
    map.on('polylinemeasure:finish', () => this.vm.handlePolylineFinish());

    if (!this.vm.hideSettingsControl) {
      this.addMapSettingsControl();
    }
    map.on('moveend', () => this.handleLandmarkViewportChange());
    map.on('zoomend', () => this.handleLandmarkViewportChange());
    this.setupPopupDelegation(map);
    this.addShipsToMap({ fitMapToBounds: true });
    this.setupResizeObserver(elementId);
  }

  // Keep the Leaflet map in sync when its container resizes (e.g. the Home
  // sidebar pushing the map narrower/wider) so tiles re-render correctly.
  setupResizeObserver(elementId) {
    if (typeof window.ResizeObserver === 'undefined') return;
    const element = document.getElementById(elementId);
    if (!element) return;
    this.resizeObserver = new window.ResizeObserver(() => {
      if (this.resizeRaf) window.cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = window.requestAnimationFrame(() => {
        if (this.map) this.map.invalidateSize({ animate: false });
      });
    });
    this.resizeObserver.observe(element);
  }

  initializeWindyMap(elementId) {
    try {
      windyInit({
        key: 'R1CTVY4LQHEtYMnM4GPV8WAFq17eFPHg',
        lat: 0,
        lon: 0,
        zoom: 10,
      }, (windyAPI) => {
        this.map = windyAPI.map;
        const {
          picker, store, overlays, broadcast,
        } = windyAPI;

        // Logika event listener untuk tombol-tombol Windy
        document.getElementById('toggle-btn').addEventListener('click', () => {
          picker.close();
          document.getElementById('button-container').classList.toggle('hidden');
        });

        // Initialize numDirection
        store.set('numDirection', false);
        let numDirection = store.get('numDirection');
        document.getElementById('btn-num-direction').addEventListener('click', (button) => {
          picker.close();
          numDirection = !numDirection;
          store.set('numDirection', numDirection);
          button.target.innerText = `${numDirection ? 'on' : 'off'}`;
        });

        // Initialize graticule
        store.set('graticule', false);
        let graticule = store.get('graticule');
        document.getElementById('btn-graticule').addEventListener('click', (button) => {
          graticule = !graticule;
          store.set('graticule', graticule);
          button.target.innerText = `${graticule ? 'on' : 'off'}`;
        });

        // Initialize latlon
        store.set('latlon', true);
        let latlon = store.get('latlon');
        document.getElementById('btn-latlon').addEventListener('click', (button) => {
          picker.close();
          latlon = !latlon;
          store.set('latlon', latlon);
          button.target.innerText = `${latlon ? 'on' : 'off'}`;
        });

        // Initialize particlesAnim
        store.set('particlesAnim', 'on');
        const availableParticlesAnim = store.getAllowed('particlesAnim');
        let particlesAnim = store.get('particlesAnim');
        document.getElementById('btn-particles-anim').addEventListener('click', (button) => {
          const idx = availableParticlesAnim.indexOf(particlesAnim);
          particlesAnim = availableParticlesAnim[(idx + 1) % availableParticlesAnim.length];
          store.set('particlesAnim', particlesAnim);
          button.target.innerText = `${particlesAnim}`;
        });

        // Initialize isolines
        store.set('isolines', 'off');
        const availableIsolines = store.getAllowed('isolines');
        let isolines = store.get('isolines');
        document.getElementById('btn-isolines').addEventListener('click', (button) => {
          const idx = availableIsolines.indexOf(isolines);
          isolines = availableIsolines[(idx + 1) % availableIsolines.length];
          store.set('isolines', isolines);
          button.target.innerText = `${isolines}`;
        });

        let currentOverlay = 'wind';

        broadcast.on('redrawFinished', (params) => {
          currentOverlay = params.overlay;
          document.getElementById('btn-metric').innerText = `${overlays[currentOverlay].metric}`;
        });

        document.getElementById('btn-metric').addEventListener('click', (button) => {
          picker.close();
          overlays[currentOverlay].cycleMetric();
          button.target.innerText = `${overlays[currentOverlay].metric}`;
        });

        // `this.map` udah diisi windyAPI.map di awal callback. Variabel `map` gak
        // pernah ada di sini — ini yang bikin ReferenceError dan matiin jalur windy.
        this.map.on('click', (e) => {
          if (this.measuring) return;
          const { lat, lng } = e.latlng;
          picker.open({ lat, lon: lng });
        });

        this.attachCommonMapBehaviour(elementId);
      });
    } catch (error) {
      console.error('Error initializing Windy map:', error);
    }
  }

  destroy() {
    if (this.map) {
      this.map.off();
      this.map.remove();
    }
    this.map = null;
    this.shipsLayerGroups = {};
    this.trail = {};
    this.dotTrail = {};
    this.trailDays = {};
    this.trailRangeKey = {};
    this.measuring = false;
    this.pointDetail = {};
    this.openPopupMassId = null;
    this.landmarks = [];
    this.landmarksLayer = null;
    this.landmarkIcon = null;
    this.lastLandmarkBoundsKey = null;
    this.lastLandmarkBounds = null;
    this.baseLayers = {};
    this.activeBaseLayerKey = null;
    this.activeBaseLayer = null;
    this.mapSettingsPanel = null;
    if (this.landmarkFetchTimeout) {
      clearTimeout(this.landmarkFetchTimeout);
      this.landmarkFetchTimeout = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.resizeRaf) {
      window.cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = null;
    }
    this.timezoneLayer = null;
    this.timezoneVisible = false;
    this.timezoneData = null;
    this.timezoneRenderer = null;
    // Clean up window reference
    window.mapServiceVm = null;
  }

  // --- Logika Penambahan Kapal dan Marker ---

  async addShipsToMap({ fitMapToBounds = true, reopenMassId = null } = {}) {
    if (!this.map) return;

    const trailPromises = [];

    this.vm.ships.forEach((ship) => {
      const shipLayerGroup = L.layerGroup();
      this.shipsLayerGroups[ship.massId] = shipLayerGroup;

      const isSatMode = this.vm.mapMode === 'sat';

      // iconConfig cuma diisi getLastData / fetchAndReconcileAssets. Halaman yang
      // gak manggil keduanya (mis. Report) dapet ship tanpa ikon, dan tanpa ini
      // markerOptions.icon jadi undefined -- yang NIMPA default Leaflet, bikin
      // _initIcon lempar "Cannot read properties of undefined (reading
      // 'createIcon')" dan kapalnya gak pernah kegambar.
      if (!ship.iconConfig) {
        const built = buildIconConfig(ship, ship.shipStatus);
        ship.iconConfig = built.iconConfig;
        ship.markerIconUrl = ship.markerIconUrl || built.markerIconUrl;
      }

      // Create icons from iconConfig
      if (!ship.icon && ship.iconConfig) {
        ship.icon = L.icon({
          iconUrl: ship.iconConfig.iconUrl,
          iconSize: ship.iconConfig.iconSize,
          popupAnchor: [0, -41],
          tooltipAnchor: [0, 0],
          className: 'ship-icon',
        });
      }

      if (!ship.markerIcon && ship.markerIconUrl) {
        ship.markerIcon = L.icon({
          iconUrl: ship.markerIconUrl,
          iconSize: scaleIconSize(MARKER_ICON_BASE_SIZE),
          className: 'marker-icon',
        });
      }

      // Create heading icon for non-default assets
      if (!ship.headingIcon && ship.iconConfig?.hasHeadingIcon) {
        // Use appropriate heading icon based on ship status
        const isSatMode = this.vm.mapMode === 'sat';
        let headingIconUrl;

        // Sat mode or online status: green heading
        if (isSatMode || ship.shipStatus === 'online') {
          headingIconUrl = headingOnline;
        } else if (ship.shipStatus === 'no-gps') {
          headingIconUrl = headingNoGps; // Gray heading for no-gps
        } else if (ship.shipStatus === 'no-sensor') {
          headingIconUrl = headingNoSensor; // Orange heading for no-sensor
        } else {
          headingIconUrl = headingOffline; // Red heading for offline
        }

        ship.headingIcon = L.icon({
          iconUrl: headingIconUrl,
          iconSize: scaleIconSize(HEADING_ICON_BASE_SIZE),
          className: 'heading-icon',
        });
      }

      const headingMarker = this.createShipHeadingMarker(ship);
      const marker = this.createShipMarker(ship);

      if (!marker) return;

      if (ship.headingIcon) {
        shipLayerGroup.addLayer(headingMarker);
      }
      shipLayerGroup.addLayer(marker);

      // `!== false`, bukan truthy: isVisible cuma diisi getLastData /
      // fetchAndReconcileAssets, jadi halaman yang gak manggil itu (mis. Report)
      // dapet undefined dan kapalnya gak pernah kegambar.
      if (ship.isVisible !== false) {
        shipLayerGroup.addTo(this.map);
      }

      // Build popup content lazily on each open so it reflects the latest ship
      // data and starts on page 1. Leaflet opens the bound popup on marker click.
      marker.bindPopup(() => {
        this.currentPopupPage = 1;
        const currentShip = this.vm.ships.find((s) => s.massId === ship.massId) || ship;
        return this.createPopupContent(currentShip);
      }, {
        maxWidth: 400,
        closeButton: true,
        autoPan: true,
      });

      marker.on('popupopen', (e) => {
        this.openPopupMassId = ship.massId;
        const currentShip = this.vm.ships.find((s) => s.massId === ship.massId) || ship;
        this.addEventListener(e.popup, currentShip);
        this.ensureShipSummary(currentShip);
      });
      marker.on('popupclose', () => {
        if (this.openPopupMassId === ship.massId) this.openPopupMassId = null;
      });

      const optionEnable = this.vm.Options?.enableTrail === 'true' || this.vm.Options?.enableTrail === true;
      // Pertahanin trail yg udah dinyalain user pas refresh/redraw (jangan ketimpa balik ke option).
      const enableTrail = this.trailCheckboxStatus[ship.massId] === true || optionEnable;
      this.trailCheckboxStatus[ship.massId] = enableTrail;
      if (enableTrail) {
        // Redraw dari cache (forceRefetch=false) & jangan fitBounds biar map ga loncat tiap pulse.
        trailPromises.push(this.toggleTrail(true, ship, this.trailDays[ship.massId] || 1, false, false));
      }

      // Kalo popup kapal ini lagi kebuka pas map di-rebuild (mis. abis fetch trail/pulse), buka lagi
      // di marker baru biar popup-nya ga ilang & ke-render ulang dari ship terbaru (yg udah ada summary).
      if (reopenMassId !== null && ship.massId === reopenMassId) {
        marker.openPopup();
      }
    });

    // Wait for all trails to be loaded
    await Promise.all(trailPromises);

    if (fitMapToBounds) this.fitMapToBounds();
  }

  async refreshShips() {
    if (!this.map) return;

    // Simpen popup yg lagi kebuka SEBELUM teardown (teardown bakal trigger popupclose -> null).
    const reopenMassId = this.openPopupMassId;

    // Clear all existing ship layer groups
    Object.keys(this.shipsLayerGroups).forEach((massId) => {
      const layerGroup = this.shipsLayerGroups[massId];
      if (this.map.hasLayer(layerGroup)) {
        this.map.removeLayer(layerGroup);
      }
      layerGroup.clearLayers();
      // clearLayers udah ngelepas polyline/dot; buang ref-nya biar guard redraw mulai bersih.
      delete this.trail[massId];
      delete this.dotTrail[massId];
    });

    // Re-add all ships with updated data (buka lagi popup yg tadi kebuka)
    await this.addShipsToMap({ fitMapToBounds: false, reopenMassId });
  }

  toggleShipVisibility(massId, isVisible) {
    const layerGroup = this.shipsLayerGroups[massId];
    if (!layerGroup) return;

    if (isVisible) {
      if (!this.map.hasLayer(layerGroup)) {
        this.map.addLayer(layerGroup);
      }
    } else if (this.map.hasLayer(layerGroup)) {
      this.map.removeLayer(layerGroup);
    }
  }

  showAllShips() {
    if (!this.map) return;
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const massId in this.shipsLayerGroups) {
      const layerGroup = this.shipsLayerGroups[massId];
      if (!this.map.hasLayer(layerGroup)) {
        this.map.addLayer(layerGroup);
      }
    }
  }

  hideAllShips() {
    if (!this.map) return;
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const massId in this.shipsLayerGroups) {
      const layerGroup = this.shipsLayerGroups[massId];
      if (this.map.hasLayer(layerGroup)) {
        this.map.removeLayer(layerGroup);
      }
    }
  }

  createShipMarker(ship) {
    const isSatMode = this.vm.mapMode === 'sat';

    const lat = typeof ship.lastLatLng?.lat === 'function' ? ship.lastLatLng.lat() : ship.lastLatLng?.lat;
    const lng = typeof ship.lastLatLng?.lng === 'function' ? ship.lastLatLng.lng() : ship.lastLatLng?.lng;

    if (lat === undefined || lng === undefined) {
      return null;
    }

    const latLng = L.latLng(lat, lng);

    // `icon` cuma diisi kalau ada: ngirim undefined bukan berarti "pakai default",
    // tapi nimpa default-nya jadi undefined.
    const markerOptions = { zIndexOffset: 2000 };
    if (ship.icon) markerOptions.icon = ship.icon;

    if (!ship.headingIcon) {
      const heading = ship.lastGpsData?.track || 0;
      markerOptions.rotationAngle = heading;
      markerOptions.rotationOrigin = '50% 50%';
    }

    const marker = L.marker(latLng, markerOptions);

    // sat mode: Always show as online
    let tooltipClass;
    if (isSatMode) {
      tooltipClass = 'ship-online';
    } else if (ship.shipStatus) {
      tooltipClass = `ship-${ship.shipStatus}`;
    } else {
      tooltipClass = ship.dataStatus && ship.lastGpsData ? 'ship-online' : 'ship-offline';
    }
    // Label lurus di tengah bawah ikon. Font & jaraknya ikut skala biar proporsional
    // (padding/radius pake em di CSS jadi ikut font). Offset y = setengah tinggi ikon
    // (udah ke-skala) + gap kecil, biar nempel pas di bawah ikon apapun ukurannya.
    const labelScale = getMapIconScale();
    const iconHeight = ship.iconConfig?.iconSize?.[1] ?? 56 * labelScale;
    marker.bindTooltip(
      `<div class="ship-label ${tooltipClass}" style="font-size:${(13 * labelScale).toFixed(1)}px">${ship.massName}</div>`,
      { permanent: true, direction: 'bottom', offset: [0, iconHeight / 2 + 4 * labelScale] },
    ).openTooltip();
    return marker;
  }

  createShipHeadingMarker(ship) {
    // Extract lat/lng to avoid Vue reactivity issues
    const lat = typeof ship.lastLatLng?.lat === 'function' ? ship.lastLatLng.lat() : ship.lastLatLng?.lat;
    const lng = typeof ship.lastLatLng?.lng === 'function' ? ship.lastLatLng.lng() : ship.lastLatLng?.lng;
    const latLng = L.latLng(lat, lng);

    return L.marker(latLng, {
      icon: ship.headingIcon,
      // Heading marker is only visual overlay; clicks should reach the ship marker popup below it.
      interactive: false,
      rotationAngle: ship.lastGpsData?.track || 0,
      rotationOrigin: '50% 50%',
      zIndexOffset: 2100, // Keep heading marker above ship marker and trails
    });
  }

  fitMapToBounds() {
    if (!this.map || this.vm.ships.length === 0) return;

    const visibleShips = this.vm.ships.filter((ship) => ship.isVisible !== false && ship.lastLatLng);
    if (visibleShips.length === 0) return;

    if (visibleShips.length === 1) {
      this.map.setView(visibleShips[0].lastLatLng, 9, {
        animate: true,
        pan: {
          duration: 1,
        },
      });
    } else {
      const group = new L.featureGroup(
        visibleShips.map((ship) => L.marker(ship.lastLatLng)),
      );
      this.map.fitBounds(group.getBounds(), { padding: [100, 100] });
    }
  }

  async toggleTrail(isChecked, ship, days = 1, forceRefetch = false, fitBounds = true) {
    this.trailCheckboxStatus[ship.massId] = isChecked;
    if (isChecked) {
      this.trailDays[ship.massId] = days;
    } else {
      delete this.trailDays[ship.massId];
    }

    if (isChecked) {
      const isSatMode = this.vm.mapMode === 'sat';

      // sat Mode: Fetch trail data from aggregated satellite GPS endpoint
      if (isSatMode && ship.massSateliteId) {
        await this.fetchAndRenderSatTrail(ship, days);
        return;
      }

      const trailPayload = {
        massId: ship.massId,
        days,
        ...(this.vm.Options?.trailRange || {}),
      };
      // Kunci rentang trail yang lagi kegambar. Start/end eksplisit dipakai apa
      // adanya; tanpa itu cukup `days`, soalnya rentangnya diturunin dari
      // lastGpsData yang gerak tiap pulse dan bakal bikin refetch terus.
      const rangeKey = trailPayload.start != null && trailPayload.end != null
        ? `${trailPayload.start}-${trailPayload.end}`
        : `d${days}`;
      const rangeChanged = this.trailRangeKey[ship.massId] !== rangeKey;

      // Guard disableSummaryFetch sengaja gak dipakai di sini: trail sekarang
      // punya endpoint sendiri yang murah, dan fetchSummary gak lagi ngisi
      // koordinat — jadi semua halaman harus narik trailnya sendiri.
      //
      // Sengaja gak nengok coordinates.length: aset yang emang nol GPS di rentang
      // ini bakal balik kosong terus, sementara tiap fetch commit SET_ASSETS ->
      // watcher -> toggleTrail lagi. rangeKey nyatet "udah pernah ditarik buat
      // rentang ini", kosong atau enggak, jadi loopnya berhenti.
      if (forceRefetch || rangeChanged) {
        // Kunci dipasang SEBELUM await: refreshShips bisa manggil toggleTrail lagi
        // selagi fetch pertama masih jalan, dan kalo kuncinya nunggu await, dua-duanya
        // lolos dan nembak request yang sama persis. Gagal -> kunci dilepas biar bisa
        // dicoba lagi.
        this.trailRangeKey[ship.massId] = rangeKey;
        try {
          await this.vm.handleFetchShipTrail(trailPayload);
          // Refresh ship reference to get updated data
          const updatedShip = this.vm.ships.find((s) => s.massId === ship.massId);
          if (updatedShip) {
            ship = updatedShip;
          }
        } catch (error) {
          delete this.trailRangeKey[ship.massId];
          console.error('[toggleTrail] Error fetching summary data:', error);
          return;
        }
      }

      const finalCoordinates = ship.coordinates?.filter((x) => x[0] !== undefined && x[1] !== undefined) || [];

      if (finalCoordinates.length === 0) {
        console.warn('[toggleTrail] No coordinates available after fetching data');
        return;
      }

      // Create trail polyline with low zIndex to keep it below markers
      // Use shipStatus to determine trail color
      let trailColor;
      switch (ship.shipStatus) {
        case 'online':
          trailColor = '#28F385'; // Green
          break;
        case 'no-sensor':
          trailColor = '#F97316'; // Orange
          break;
        case 'no-gps':
          trailColor = '#9CA3AF'; // Gray
          break;
        default:
          trailColor = '#FF3B30'; // Red (offline)
      }
      // Bersihin polyline lama dulu kalo masih ada (mis. refetch range tanpa toggle off duluan).
      if (this.trail[ship.massId]) {
        this.shipsLayerGroups[ship.massId].removeLayer(this.trail[ship.massId]);
        delete this.trail[ship.massId];
        this.toggleDotTrail(false, ship);
      }
      const trailLayer = L.polyline(finalCoordinates, {
        color: trailColor,
        weight: 4,
        zIndexOffset: -1000, // Keep trail below all markers
      });
      this.shipsLayerGroups[ship.massId].addLayer(trailLayer);
      this.trail[ship.massId] = trailLayer;
      if (fitBounds) this.map.fitBounds(trailLayer.getBounds());
      this.toggleDotTrail(true, ship);
    } else if (this.trail[ship.massId]) {
      this.shipsLayerGroups[ship.massId].removeLayer(this.trail[ship.massId]);
      delete this.trail[ship.massId];
      this.toggleDotTrail(false, ship);
    }
  }

  async fetchAndRenderSatTrail(ship, days = 1) {
    try {
      // Calculate time range (last N days, ngikut pilihan chip trail)
      const lastTimestamp = ship.lastGpsData?.timestamp || Math.floor(Date.now() / 1000);
      const startTimestamp = Math.floor(lastTimestamp / 3600) * 3600 - (days * 86400);
      const endTimestamp = Math.floor(Date.now() / 1000);

      // Fetch GPS, RPM, and AE data in parallel
      const [gpsResponse, rpmResponse, aeResponse] = await Promise.all([
        SeriesSvc.getAggregatedSatelliteGpsByPeriod(startTimestamp, endTimestamp, {
          params: {
            device: [ship.massSateliteId],
          },
        }),
        SeriesSvc.getAggregatedSatelliteRpmByPeriod(startTimestamp, endTimestamp, {
          params: {
            device: [ship.massSateliteId],
          },
        }),
        SeriesSvc.getAggregatedSatelliteAeByPeriod(startTimestamp, endTimestamp, {
          params: {
            device: [ship.massSateliteId],
          },
        }),
      ]);

      const gpsSeries = gpsResponse?.data?.data?.series || [];
      const rpmSeries = rpmResponse?.data?.data?.series || [];
      const aeSeries = aeResponse?.data?.data?.series || [];

      if (gpsSeries.length === 0) {
        return;
      }

      // Group RPM data by hour for matching
      const rpmByHour = new Map();
      rpmSeries.forEach((rpmData) => {
        const hour = Math.floor(rpmData.timestamp / 3600);
        if (!rpmByHour.has(hour)) {
          rpmByHour.set(hour, []);
        }
        rpmByHour.get(hour).push(rpmData);
      });

      // Group AE data by hour for matching
      const aeByHour = new Map();
      aeSeries.forEach((aeData) => {
        const hour = Math.floor(aeData.timestamp / 3600);
        if (!aeByHour.has(hour)) {
          aeByHour.set(hour, []);
        }
        aeByHour.get(hour).push(aeData);
      });

      // Merge GPS, RPM, and AE data by matching hour (ignore minutes)
      const mergedSeries = gpsSeries.map((gpsPoint) => {
        const gpsHour = Math.floor(gpsPoint.timestamp / 3600);
        const matchingRpmData = rpmByHour.get(gpsHour) || [];
        const matchingAeData = aeByHour.get(gpsHour) || [];

        // Find RPM data for all types (PORT, STARBOARD, CENTER)
        const portRpm = matchingRpmData.find((r) => r.type === 'PORT');
        const starboardRpm = matchingRpmData.find((r) => r.type === 'STARBOARD');
        const centerRpm = matchingRpmData.find((r) => r.type === 'CENTER');

        // Find AE data for this hour (get the one with highest no or status = 1)
        const activeAe = matchingAeData.find((ae) => ae.status === 1) || matchingAeData[0];

        return {
          ...gpsPoint,
          portRpm: portRpm?.rpm || null,
          starboardRpm: starboardRpm?.rpm || null,
          centerRpm: centerRpm?.rpm || null,
          portRunningMinutes: portRpm?.runningMinutes || null,
          starboardRunningMinutes: starboardRpm?.runningMinutes || null,
          centerRunningMinutes: centerRpm?.runningMinutes || null,
          currentAe: activeAe?.no || null,
          aeRunningMinutes: activeAe?.runningMinutes || null,
          aeStatus: activeAe?.status || null,
          track: gpsPoint.track || gpsPoint.heading || 0,
        };
      });

      // Extract coordinates from merged series
      const coordinates = mergedSeries.map((point) => [point.latitude, point.longitude]);

      // Create trail polyline with low zIndex and green color for sat
      const trailLayer = L.polyline(coordinates, {
        color: '#28F385', // Green for sat mode
        weight: 4,
        zIndexOffset: -1000, // Keep trail below all markers
      });
      this.shipsLayerGroups[ship.massId].addLayer(trailLayer);
      this.trail[ship.massId] = trailLayer;
      this.map.fitBounds(trailLayer.getBounds());

      // Create dot trail markers with popup data
      this.dotTrail[ship.massId] = [];
      const SatMarkerIcon = L.icon({
        iconUrl: markerOnline,
        iconSize: scaleIconSize(MARKER_ICON_BASE_SIZE),
        className: 'marker-icon',
      });

      // Skip the last (most recent) data point
      const seriesToRender = mergedSeries.slice(0, -1);
      seriesToRender.forEach((data) => {
        const marker = L.marker([data.latitude, data.longitude], {
          icon: SatMarkerIcon, // Always use online icon for sat dot trail
          rotationAngle: data.track || 0,
          rotationOrigin: '50% 50%',
          zIndexOffset: 1000, // Keep markers above trails
        });
        marker.bindPopup(() => this.createSatDotTrailPopupContent(ship, data));
        this.dotTrail[ship.massId].push(marker);
        this.shipsLayerGroups[ship.massId].addLayer(marker);
      });
    } catch (error) {
      console.error('[fetchAndRenderSatTrail] Error fetching trail data:', error);
    }
  }

  createSatDotTrailPopupContent(ship, data) {
    const timestamp = data?.timestamp || data?.gpsData?.timestamp;
    const datetime = timestamp ? formatDateTime(timestamp * 1000, 'DD MMM YYYY HH:mm:ss') : '-';
    const latitude = data?.latitude;
    const longitude = data?.longitude;
    const speed = data?.speed;
    const headingValue = data?.track ?? data?.heading ?? null;
    const headingDisplay = Number.isFinite(Number(headingValue)) ? `${Number(headingValue).toFixed(2)}°` : '-';
    const portRpm = data?.portRpm;
    const starboardRpm = data?.starboardRpm;
    const centerRpm = data?.centerRpm;
    const currentAe = data?.currentAe;

    const latDMS = latitude ? convertDecimalToDMS(latitude, true) : '-';
    const lngDMS = longitude ? convertDecimalToDMS(longitude, false) : '-';
    const coordinateDisplay = `${latDMS}, ${lngDMS}`;

    // Build RPM HTML dynamically
    let rpmHtml = '';
    if (portRpm !== null && portRpm !== undefined) {
      rpmHtml += `<div class="col-6" style="height: 50px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Port RPM</p><p style="font-weight: 1000; color: #1e1e1e">${portRpm.toFixed(2)}</p></div>`;
    }
    if (starboardRpm !== null && starboardRpm !== undefined) {
      rpmHtml += `<div class="col-6" style="height: 50px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Starboard RPM</p><p style="font-weight: 1000; color: #1e1e1e">${starboardRpm.toFixed(2)}</p></div>`;
    }
    if (centerRpm !== null && centerRpm !== undefined) {
      rpmHtml += `<div class="col-6" style="height: 50px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Center RPM</p><p style="font-weight: 1000; color: #1e1e1e">${centerRpm.toFixed(2)}</p></div>`;
    }
    if (!rpmHtml) {
      rpmHtml = '<div class="col-12" style="height: 50px"><p style="margin-top: 0; margin-bottom: -10px">No RPM data available</p></div>';
    }

    // Determine status class dynamically
    const statusClass = ship.shipStatus || 'online';

    return `
      <div class="row pt-3">
        <div class="col-6 d-flex align-items-center"><h6>${ship.massName || '-'}</h6></div>
        <div class="col-6 d-flex justify-content-end align-items-center pt-0"><span class="status ${statusClass}">${statusClass}</span></div>
      </div>
      <hr style="margin: 12px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 13px"><b>Time: </b> ${datetime}</p></div></div>
      <hr style="margin: 12px 0;" />
      <div class="row info-section pb-2">
        <div class="col-12" style="height: 60px">
          <p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Coordinates</p>
          <p style="font-weight: 1000; color: #1e1e1e">${coordinateDisplay}</p>
        </div>
        ${rpmHtml}
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Speed</p>
          <p style="font-weight: 1000; color: #1e1e1e">${speed !== null ? `${speed.toFixed(2)} knot` : '-'}</p>
        </div>
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Heading</p>
          <p style="font-weight: 1000; color: #1e1e1e">${headingDisplay}</p>
        </div>
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px">Active AE</p>
          <p style="font-weight: 1000; color: #1e1e1e">${currentAe !== null ? `AE ${currentAe}` : '-'}</p>
        </div>
      </div>
    `;
  }

  toggleDotTrail(isChecked, ship) {
    if (isChecked) {
      const isSatMode = this.vm.mapMode === 'sat';
      const coordinatesData = ship.coordinatesData.filter((x) => x.latLong[0] !== undefined && x.latLong[1] !== undefined);
      this.dotTrail[ship.massId] = this.dotTrail[ship.massId] || [];

      // sat mode: Always use online marker icon
      const markerIcon = isSatMode ? markerOnline : ship.markerIcon;

      coordinatesData.forEach((data) => {
        const marker = L.marker(data.latLong, {
          icon: markerIcon,
          rotationAngle: data.heading || 0,
          rotationOrigin: '50% 50%',
          zIndexOffset: 1000, // Keep dot markers above trails but below ship marker
        });
        marker.bindPopup(() => this.createDotTrailPopupContent(ship, data));
        marker.on('popupopen', (e) => {
          this.currentDotTrailPopupPage = 1;
          const render = () => {
            const fresh = this.vm.ships.find((s) => s.massId === ship.massId) || ship;
            e.target.setPopupContent(this.createDotTrailPopupContent(fresh, data));
            this.setupDotTrailPaginationButtons(e.target, fresh, data);
          };
          render();

          // Detail RPM/AE/Total Cruise ditarik per titik, rentang satu jam.
          const shipNow = this.vm.ships.find((s) => s.massId === ship.massId) || ship;
          const cached = this.pointDetail[ship.massId]?.[data.timestamp] || shipNow.trailPointDetail?.[data.timestamp];
          if (!cached && data.timestamp) {
            this.vm.handleFetchTrailPointDetail({ massId: ship.massId, timestamp: data.timestamp })
              .then((detail) => {
                // simpan ke cache lokal, bukan Vuex, biar gak commit -> rebuild map -> popup nutup sendiri
                if (detail) {
                  if (!this.pointDetail[ship.massId]) this.pointDetail[ship.massId] = {};
                  this.pointDetail[ship.massId][data.timestamp] = detail;
                }
                render();
              })
              .catch((err) => console.warn('[dotTrail] detail titik gagal difetch', err));
          }

          // Rollup udah bawa nama zona di lastPosition.zone.name, jadi
          // reverse-geocode cuma dipanggil kalau detailnya gagal/belum ada.
          const detailPunyaLokasi = cached && cached.locationText;
          if (data.locationText === undefined && !detailPunyaLokasi) {
            describeLocation(data.latLong[0], data.latLong[1]).then((text) => {
              data.locationText = text;
              if (this.currentDotTrailPopupPage === 1) render();
            });
          }
        });
        this.dotTrail[ship.massId].push(marker);
        this.shipsLayerGroups[ship.massId].addLayer(marker);
      });
    } else if (this.dotTrail[ship.massId]) {
      this.dotTrail[ship.massId].forEach((marker) => {
        this.shipsLayerGroups[ship.massId].removeLayer(marker);
      });
      delete this.dotTrail[ship.massId];
    }
  }

  // --- Logika Popup ---

  updatePopupContent(popup, ship) {
    const newPopupContent = this.createPopupContent(ship);
    popup.setContent(newPopupContent);
    this.addEventListener(popup, ship); // Re-attach listeners
  }

  addEventListener(popup, ship) {
    this.setupButtonEvent(`report-${ship.massId}`, () => this.vm.handleClickReport(ship.massId));
    this.setupButtonEvent(`dashboard-${ship.massId}`, () => this.vm.handleClickDashboard(ship.massId));
    this.setupButtonEvent(`voyage-${ship.massId}`, () => this.vm.handleClickVoyage(ship.massId));

    // Pager device-aware: wrap-around (mirror sidebar), tombol mati cuma kalo 1 page.
    this.setupButtonEvent(`previous-popup-button-${ship.massId}`, () => {
      const total = this.totalPopupPages || 1;
      if (total < 2) return;
      this.currentPopupPage = ((this.currentPopupPage - 2 + total) % total) + 1;
      this.updatePopupContent(popup, ship);
    });
    this.setupButtonEvent(`next-popup-button-${ship.massId}`, () => {
      const total = this.totalPopupPages || 1;
      if (total < 2) return;
      this.currentPopupPage = (this.currentPopupPage % total) + 1;
      this.updatePopupContent(popup, ship);
    });

    // Switch trail & chip rentang sengaja gak dipasang di sini — lihat
    // setupPopupDelegation(). Isi popup dibikin dari fungsi, dan Leaflet render
    // ulang DOM-nya di luar updatePopupContent, jadi listener yang nempel ke node
    // ikut kebuang.
  }

  // Delegasi satu kali di container peta. Tahan terhadap berapa kali pun Leaflet
  // bikin ulang isi popup, soalnya yang didengerin containernya, bukan node-nya.
  setupPopupDelegation(map) {
    map.getContainer().addEventListener('change', (event) => {
      const el = event.target;
      const id = (el && el.id) || '';
      const trail = id.match(/^trail-switch-(\d+)$/);
      const dot = id.match(/^dot-trail-switch-(\d+)$/);
      if (!trail && !dot) return;

      const massId = (trail || dot)[1];
      const ship = this.vm.ships.find((s) => String(s.massId) === String(massId));
      if (!ship) return;

      if (dot) {
        this.toggleDotTrail(el.checked, ship);
        return;
      }

      const isChecked = el.checked;
      (async () => {
        if (isChecked) await this.vm.handleGetLastData(this.vm.mapMode || 'standard');
        // Nyalain = paksa refetch biar window ngikut chip yg dipilih (mirror sidebar).
        await this.toggleTrail(isChecked, ship, this.trailDays[ship.massId] || 1, isChecked === true);
        this.refreshOpenPopup(ship.massId);
      })();
    });

    // Chip rentang trail (1/3/7/14 hari).
    map.getContainer().addEventListener('click', (event) => {
      const id = (event.target && event.target.id) || '';
      const hit = id.match(/^trail-day-(\d+)-(\d+)$/);
      if (!hit) return;
      const massId = hit[1];
      const days = Number(hit[2]);
      if (!TRAIL_DAY_OPTIONS.includes(days)) return;
      const ship = this.vm.ships.find((s) => String(s.massId) === String(massId));
      if (!ship || (this.trailDays[massId] || 1) === days) return;

      this.trailDays[massId] = days;
      (async () => {
        if (this.trailCheckboxStatus[massId] === true) {
          await this.toggleTrail(true, ship, days, true);
        }
        this.refreshOpenPopup(massId);
      })();
    });
  }

  // Cari popup kapal yang lagi kebuka, lalu render ulang isinya.
  refreshOpenPopup(massId) {
    if (!this.map || this.openPopupMassId !== massId) return;
    const layers = this.shipsLayerGroups[massId] && this.shipsLayerGroups[massId].getLayers();
    const popup = (layers || [])
      .map((l) => l.getPopup && l.getPopup())
      .find((p) => p && this.map.hasLayer(p));
    const ship = this.vm.ships.find((s) => String(s.massId) === String(massId));
    if (popup && ship) this.updatePopupContent(popup, ship);
  }

  setupButtonEvent(buttonId, callback) {
    setTimeout(() => {
      const button = document.getElementById(buttonId);
      if (button) {
        button.onclick = callback;
      }
    }, 0);
  }

  get isCompactPopup() {
    const opt = this.vm.Options || {};
    return opt.compactPopup === true || opt.compactPopup === 'true';
  }

  // Trail stats ditarik pas user minta detail (buka popup / expand panel),
  // bukan pas gambar garis. Dashboard & Report udah punya summary dari
  // halamannya, jadi kelewat di sini.
  async ensureShipSummary(ship) {
    if (!ship) return;
    // Popup sat pakai createSatPopupContent, stats-nya gak kepake sama sekali.
    if (this.vm.mapMode === 'sat') return;
    if (this.vm.Options?.disableSummaryFetch === true) return;
    // Gak ada cek rangeKey di sini — action fetchShipSummary yang pegang guard
    // itu, biar logika rentangnya cuma hidup di satu tempat.

    try {
      await this.vm.handleFetchShipSummary({
        massId: ship.massId,
        days: this.trailDays[ship.massId] || 1,
        ...(this.vm.Options?.trailRange || {}),
      });
    } catch (e) {
      console.warn('[ensureShipSummary] gagal, popup tetap tampil tanpa stats', e);
      return;
    }

    const updated = this.vm.ships.find((s) => s.massId === ship.massId);
    const popup = this.map && this.openPopupMassId === ship.massId
      ? this.shipsLayerGroups[ship.massId]?.getLayers()
        .map((l) => l.getPopup && l.getPopup())
        .find((p) => p && this.map.hasLayer(p))
      : null;
    if (updated && popup) this.updatePopupContent(popup, updated);
  }

  createPopupContent(ship) {
    const isSatMode = this.vm.mapMode === 'sat';

    if (isSatMode) {
      // sat mode: Only show GPS data
      return this.createSatPopupContent(ship);
    }

    // Standard mode: pager device-aware (mirror sidebar lewat util vesselDetail)
    const userAccess = this.vm.$store?.getters['auth/userAccess'];
    const groups = buildDetailGroups(ship, userAccess);
    this.totalPopupPages = groups.length || 1;
    if (this.currentPopupPage > this.totalPopupPages || this.currentPopupPage < 1) {
      this.currentPopupPage = 1;
    }
    const activeGroup = groups[this.currentPopupPage - 1] || groups[0];
    const lastData = ship.lastGpsData?.timestamp
      ? formatDateTime(ship.lastGpsData.timestamp * 1000, 'DD MMM YYYY HH:mm:ss')
      : '-';

    return /* html */`
      <div class="row pt-3">
        <div class="col-7 d-flex align-items-center"><h5 style="margin: 0;">${ship.massName || '-'}</h5></div>
        <div class="col-5 d-flex justify-content-end align-items-center">${this.renderStatusBadge(ship)}</div>
      </div>
      <hr style="margin: 10px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 13px"><b>Last Data:</b> ${lastData}</p></div></div>
      <hr style="margin: 10px 0;" />
      ${this.renderDetailPager(ship, groups)}
      ${this.renderGroupBody(activeGroup)}
      ${this.isCompactPopup ? '' : /* html */`
      <hr style="margin: 10px 0;" />
      <div class="row pb-2">${this.renderTrailPanelFull(ship)}</div>
      <hr style="margin: 10px 0;" />
      <div class="row button-section">${this.renderActionButtons(ship)}</div>`}
    `;
  }

  createSatPopupContent(ship) {
    const gpsData = ship.lastGpsData;
    const latitude = gpsData?.latitude ?? gpsData?.lat;
    const longitude = gpsData?.longitude ?? gpsData?.lng;
    const timestamp = gpsData?.timestamp;
    const datetime = timestamp ? formatDateTime(timestamp * 1000, 'DD MMM YYYY HH:mm:ss') : '-';

    const speedValue = gpsData?.speed ?? null; // backend provides speed in KNOT
    const headingValue = gpsData?.track ?? gpsData?.heading ?? null;
    const headingDisplay = Number.isFinite(Number(headingValue)) ? `${Number(headingValue).toFixed(2)}°` : '-';

    // Convert decimal coordinates to DMS
    const latDMS = latitude ? convertDecimalToDMS(latitude, true) : '-';
    const lngDMS = longitude ? convertDecimalToDMS(longitude, false) : '-';
    const coordinateDisplay = latitude && longitude ? `${latDMS}, ${lngDMS}` : '-';

    // Get RPM data - extract unique types from lastRpmData
    const rpmTypes = [...new Set((ship.lastRpmData || []).map((rpm) => rpm.type))];
    const displayLabels = rpmTypes.map((type) => getRpmTypeLabel(type, rpmTypes));

    // Build RPM HTML dynamically based on available types
    let rpmHtml = '';
    rpmTypes.forEach((type, index) => {
      const rpmData = ship.lastRpmData?.find((rpm) => rpm.type === type);
      const rpmValue = Math.floor(rpmData?.rpm || 0);
      const displayLabel = displayLabels[index];
      rpmHtml += `
        <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">${displayLabel} RPM</p><p style="font-weight: 1000; color: #1e1e1e">${rpmValue}</p></div>
      `;
    });

    // Get AE data
    const activeAe = ship.lastAeData?.find((ae) => ae.status === 1) || ship.lastAeData?.[0];
    const currentAe = activeAe?.no;

    const infoHTML = `
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Coordinates</p><p style="font-weight: 1000; color: #1e1e1e">${coordinateDisplay}</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Speed</p><p style="font-weight: 1000; color: #1e1e1e">${speedValue !== null ? `${speedValue.toFixed(2)} knot` : '-'}</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Heading</p><p style="font-weight: 1000; color: #1e1e1e">${headingDisplay}</p></div>
      ${rpmHtml}
      ${currentAe !== null && currentAe !== undefined ? `
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Active AE</p><p style="font-weight: 1000; color: #1e1e1e">AE ${currentAe}</p></div>
      ` : ''}
    `;

    // sat mode: Always show as online
    return /* html */`
      <div class="row pt-3">
        <div class="col-6 d-flex align-items-center"><h5>${ship.massName || '-'}</h5></div>
        <div class="col-6 d-flex justify-content-end align-items-center pt-0"><h5 class="status online">online</h5></div>
      </div>
      <hr style="margin: 12px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 14px"><b>Last Data: </b> ${datetime}</p></div></div>
      <hr style="margin: 12px 0;" />
      <div class="row info-section pb-2">${infoHTML}</div>
      <hr style="margin: 12px 0;" />
      <div class="row pb-3">${this.renderTrailSwitches(ship, true)}</div>
      <hr style="margin: 12px 0;" />
      <div class="row button-section">${this.renderActionButtons(ship)}</div>
    `;
  }

  renderStatusBadge(ship) {
    const color = shipStatusColor(ship);
    const label = shipStatusLabel(ship);
    return `<span style="display:inline-block;padding:2px 10px;border-radius:10px;font-size:12px;font-weight:700;color:#fff;background:${color};">${label}</span>`;
  }

  renderDetailPager(ship, groups, page = this.currentPopupPage, idSuffix = '') {
    const total = groups.length;
    const idx = page - 1;
    const group = groups[idx] || groups[0] || { label: '' };
    const dots = total > 1
      ? `<div style="display:flex;gap:4px;justify-content:center;margin:6px 0 2px;">${groups
        .map((g, i) => `<span style="width:6px;height:6px;border-radius:50%;background:${i === idx ? '#ff69b4' : '#d3d9e3'};"></span>`)
        .join('')}</div>`
      : '';
    return /* html */`
      <div style="display:flex;align-items:center;gap:8px;">
        <div style="flex:1;font-weight:700;font-size:13px;color:#1f2937;">
          ${group.label}
          <span style="color:#8a93a5;font-weight:500;">${idx + 1}/${total}</span>
        </div>
        <button class="btn btn-sm btn-outline-mantraz" style="padding:1px 9px;" id="previous-popup-button-${ship.massId}${idSuffix}" ${total < 2 ? 'disabled' : ''}>&lsaquo;</button>
        <button class="btn btn-sm btn-outline-mantraz" style="padding:1px 9px;" id="next-popup-button-${ship.massId}${idSuffix}" ${total < 2 ? 'disabled' : ''}>&rsaquo;</button>
      </div>
      ${dots}
    `;
  }

  renderGroupBody(group) {
    if (!group) return '';

    // Fuel: card kecil per flowmeter (Flow/Temp/Density) + jam datanya sendiri.
    if (group.cards) {
      const cards = group.cards.map((card) => {
        const metrics = card.rows.map((r) => `
          <div style="text-align:center;">
            <div style="font-size:10px;color:#8a93a5;">${r.label}</div>
            <div style="font-size:13px;font-weight:700;color:#1f2937;">${r.value}</div>
          </div>`).join('');
        const time = card.time
          ? `<div style="margin-top:6px;padding-top:6px;border-top:1px dashed #e6eaf1;font-size:10px;color:#1f2937;"><b>${card.time.date}</b> <b>${card.time.time}</b></div>`
          : '';
        return `
          <div style="border:1px solid #e6eaf1;border-radius:8px;background:#fafbfc;padding:8px;margin-bottom:6px;">
            <div style="font-size:11px;font-weight:700;color:#264284;text-transform:uppercase;margin-bottom:4px;">${card.title}</div>
            <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:4px;">${metrics}</div>
            ${time}
          </div>`;
      }).join('');
      return `<div style="padding:8px 4px 0;">${cards}</div>`;
    }

    // Sections: tiap section punya timestamp di atas + rows, dipisah garis dashed.
    if (group.sections) {
      const html = group.sections.map((section, idx) => {
        const sep = idx > 0 ? '<div style="border-top:1px dashed #e6eaf1;margin:8px 0;"></div>' : '';
        let timeHtml = '';
        if (section.time) {
          const t = splitDataTime(section.time) || { date: '', time: '' };
          timeHtml = `<div style="display:flex;gap:5px;font-size:11px;color:#8a93a5;margin-bottom:6px;"><i class="ri-time-line"></i><b style="color:#1f2937;">${t.date}</b><b style="color:#1f2937;">${t.time}</b></div>`;
        }
        const rowsHtml = (section.rows || []).map((r) => `
          <div class="${r.full ? 'col-12' : 'col-6'}" style="margin-bottom:8px;">
            <div style="font-size:11px;color:#8a93a5;">${r.label}</div>
            <div style="font-size:13px;font-weight:700;color:#1f2937;word-break:break-word;">${r.value}</div>
          </div>`).join('');
        return `${sep}${timeHtml}<div class="row" style="padding:0 4px;">${rowsHtml}</div>`;
      }).join('');
      return `<div style="padding:8px 4px 0;">${html}</div>`;
    }

    // Grid label/value biasa + jam data per page.
    const rows = (group.rows || []).map((r) => `
      <div class="${r.full ? 'col-12' : 'col-6'}" style="margin-bottom:8px;">
        <div style="font-size:11px;color:#8a93a5;">${r.label}</div>
        <div style="font-size:13px;font-weight:700;color:#1f2937;word-break:break-word;">${r.value}</div>
      </div>`).join('');
    let time = '';
    if (group.time) {
      const t = splitDataTime(group.time) || { date: '', time: '' };
      time = `<div style="display:flex;gap:5px;padding:6px 8px 0;font-size:11px;color:#1f2937;"><b>${t.date}</b> <b>${t.time}</b></div>`;
    }
    return `<div class="row" style="padding:8px 4px 0;">${rows}</div>${time}`;
  }

  renderTrailPanelFull(ship) {
    const isChecked = this.trailCheckboxStatus[ship.massId] === true;
    const hasDotTrail = this.dotTrail[ship.massId] && this.dotTrail[ship.massId].length > 0;
    const activeDays = this.trailDays[ship.massId] || 1;

    // Halaman yang ngunci rentang lewat Options.trailRange gak nampilin chip:
    // start/end eksplisit selalu menang atas `days`, jadi chip-nya gak ngefek.
    const lockedRange = this.vm.Options?.trailRange;
    const chips = lockedRange ? '' : TRAIL_DAY_OPTIONS.map((d) => {
      const style = activeDays === d
        ? 'background:#264284;border:1px solid #264284;color:#fff;'
        : 'background:#fff;border:1px solid #e6eaf1;color:#6b7280;';
      return `<button type="button" class="trail-day-chip" id="trail-day-${ship.massId}-${d}" style="${style}padding:1px 7px;border-radius:6px;font-size:11px;font-weight:600;margin-left:4px;cursor:pointer;">${d}d</button>`;
    }).join('');

    const stats = buildTrailStats(ship);
    let body;
    if (isChecked && stats.length) {
      const cells = stats.map((s) => `
        <div style="margin-bottom:4px;">
          <div style="font-size:10px;color:#8a93a5;text-transform:uppercase;">${s.label}</div>
          <div style="font-size:13px;font-weight:700;color:#1f2937;">${s.value}</div>
        </div>`).join('');
      body = `<div style="display:grid;grid-template-columns:1fr 1fr;gap:2px 12px;margin-top:8px;padding:8px;border:1px solid #e6eaf1;border-radius:8px;background:#fafbfc;">${cells}</div>`;
    } else {
      const hint = isChecked
        ? `No trail data for the last ${activeDays}-day window.`
        : `Enable Vessel Trail to see the last ${activeDays}-day summary.`;
      body = `<div style="margin-top:8px;font-size:11px;font-style:italic;color:#8a93a5;">${hint}</div>`;
    }

    return /* html */`
      <div class="col-12">
        <div style="display:flex;align-items:center;justify-content:space-between;">
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="trail-switch-${ship.massId}" ${isChecked ? 'checked' : ''} />
            <label class="custom-control-label" for="trail-switch-${ship.massId}">Vessel Trail</label>
          </div>
          <div>${chips}</div>
        </div>
        ${body}
        ${isChecked ? `
        <div class="custom-control custom-switch" style="margin-top:8px;">
          <input type="checkbox" class="custom-control-input" id="dot-trail-switch-${ship.massId}" ${hasDotTrail ? 'checked' : ''} />
          <label class="custom-control-label" for="dot-trail-switch-${ship.massId}">Dot Trail</label>
        </div>` : ''}
      </div>
    `;
  }

  renderTrailSwitches(ship, isSatMode = false) {
    const isChecked = this.trailCheckboxStatus[ship.massId];
    const hasDotTrail = this.dotTrail[ship.massId] && this.dotTrail[ship.massId].length > 0;

    // sat mode: No pagination buttons (only 1 page)
    if (isSatMode) {
      return /* html */`
        <div class="col-12 d-flex justify-content-between align-items-center">
          <div>
            <div class="custom-control custom-switch mr-2">
              <input type="checkbox" class="custom-control-input" id="trail-switch-${ship.massId}" ${isChecked ? 'checked' : ''} />
              <label class="custom-control-label" for="trail-switch-${ship.massId}">Vessel Trail</label>
            </div>
            ${isChecked ? `
            <div class="custom-control custom-switch mr-2">
              <input type="checkbox" class="custom-control-input" id="dot-trail-switch-${ship.massId}" ${hasDotTrail ? 'checked' : ''} />
              <label class="custom-control-label" for="dot-trail-switch-${ship.massId}">Dot Trail</label>
            </div>` : ''}
          </div>
          <button class="btn btn-sm btn-mantraz" style="display: flex; align-items: center; justify-content: center;" onclick="window.mapServiceVm.viewSatelliteDatalog('${ship.massId}')">
            <i class="fas fa-file-alt mr-2"></i>View Log
          </button>
        </div>
      `;
    }

    // Standard mode: With pagination buttons
    return /* html */`
      <div class="col-6" style="height: 15px">
        <div class="custom-control custom-switch mr-2">
          <input type="checkbox" class="custom-control-input" id="trail-switch-${ship.massId}" ${isChecked ? 'checked' : ''} />
          <label class="custom-control-label" for="trail-switch-${ship.massId}">Vessel Trail</label>
        </div>
        ${isChecked ? `
        <div class="custom-control custom-switch mr-2">
          <input type="checkbox" class="custom-control-input" id="dot-trail-switch-${ship.massId}" ${hasDotTrail ? 'checked' : ''} />
          <label class="custom-control-label" for="dot-trail-switch-${ship.massId}">Dot Trail</label>
        </div>` : ''}
      </div>
      <div class="col-6 d-flex justify-content-end">
        <button class="btn btn-sm btn-outline-mantraz mr-1" id="previous-popup-button-${ship.massId}" ${this.currentPopupPage === 1 ? 'disabled' : ''}>Previous</button>
        <button class="btn btn-sm btn-outline-mantraz" id="next-popup-button-${ship.massId}" ${this.currentPopupPage === this.totalPopupPages ? 'disabled' : ''}>Next</button>
      </div>
    `;
  }

  renderActionButtons(ship) {
    const userAccess = this.vm.$store?.getters['auth/userAccess'] || {};
    let content = '';
    if (userAccess.summary_aggregated?.includes('read')) {
      content += /* html */`
        <div class="col-6 my-1"><button class="btn btn-sm btn-block btn-mantraz tooltip-button" id="report-${ship.massId}">View Report</button></div>
        <div class="col-6 my-1"><button class="btn btn-sm btn-block btn-outline-mantraz tooltip-button" id="dashboard-${ship.massId}">View Dashboard</button></div>
      `;
    }
    const hideVoyageButton = this.vm.Options?.hideVoyageButton === true || this.vm.Options?.hideVoyageButton === 'true';
    if (!hideVoyageButton && userAccess.voyage_master?.includes('read')) {
      content += `<div class="col-12 my-1"><button class="btn btn-sm btn-block btn-mantraz tooltip-button" id="voyage-${ship.massId}">Voyage Report</button></div>`;
    }
    return content;
  }

  // --- Dot Trail Popup ---

  // Bentuknya disamain sama buildDetailGroups biar bisa dirender pager & body
  // yang sama kayak popup kapal.
  buildDotTrailGroups(data, detail) {
    // key undefined di detail jangan nimpa isi data (mis. locationText hasil geocode).
    const src = { ...data };
    Object.entries(detail || {}).forEach(([k, v]) => { if (v !== undefined) src[k] = v; });
    const num = (v) => Number.isFinite(Number(v));
    const lat = src?.latLong?.[0];
    const lng = src?.latLong?.[1];
    // speedKnots dari rollup udah knot — jangan diconvert lagi. Field speed/
    // avgSpeed (dari processSummarySeriesData) masih km/h, itu yang diconvert.
    const speedKn = Number.isFinite(Number(src?.speedKnots))
      ? Number(src.speedKnots)
      : convertKmhToKnots(src?.speed ?? src?.gpsData?.speed ?? src?.avgSpeed ?? null);

    const rows = [
      {
        label: 'Coordinates',
        value: num(lat) && num(lng)
          ? `${convertDecimalToDMS(lat, true)}, ${convertDecimalToDMS(lng, false)}`
          : '-',
        full: true,
      },
      { label: 'Location', value: src.locationText || '-', full: true },
      { label: 'Speed', value: speedKn !== null ? `${speedKn.toFixed(2)} kn` : '-' },
      { label: 'Heading', value: num(src?.heading) ? `${Math.round(src.heading)}°` : '-' },
      { label: 'Total Cruise', value: num(src?.totalCruise) ? `${(src.totalCruise / 1852).toFixed(2)} NM` : '-' },
      { label: 'Current AE', value: src?.currentAe ? `AE ${src.currentAe}` : '-' },
    ];
    const groups = [{ label: 'Position', rows }];

    const rpmOf = (type) => {
      const key = `${type.toLowerCase()}Rpm`;
      return (src || {})[key];
    };
    const rpmTypes = ['PORT', 'STARBOARD', 'CENTER'].filter((type) => num(rpmOf(type)));
    if (rpmTypes.length) {
      groups.push({
        label: 'RPM',
        rows: rpmTypes.map((type) => ({
          label: `${getRpmTypeLabel(type, rpmTypes)} RPM`,
          value: Number(rpmOf(type)).toFixed(2),
        })),
      });
    }
    return groups;
  }

  createDotTrailPopupContent(ship, data) {
    // cache lokal dicek duluan - trailPointDetail store cuma keisi dari fetchSummary (Dashboard/Report)
    const detail = this.pointDetail[ship.massId]?.[data.timestamp]
      || ship.trailPointDetail?.[data.timestamp];
    const groups = this.buildDotTrailGroups(data, detail);
    if (this.currentDotTrailPopupPage > groups.length || this.currentDotTrailPopupPage < 1) {
      this.currentDotTrailPopupPage = 1;
    }
    const activeGroup = groups[this.currentDotTrailPopupPage - 1] || groups[0];
    const suffix = `-${data.timestamp}`;
    const lastData = data.gpsData?.timestamp
      ? formatDateTime(data.gpsData.timestamp * 1000, 'DD MMM YYYY HH:mm:ss')
      : '-';
    const rangeLabel = hourWindowLabel(data.timestamp);

    return /* html */`
      <div class="row pt-3">
        <div class="col-7 d-flex align-items-center"><h5 style="margin: 0;">${ship.massName || '-'}</h5></div>
        <div class="col-5 d-flex justify-content-end align-items-center">${this.renderStatusBadge(ship)}</div>
      </div>
      <hr style="margin: 10px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 13px"><b>Last Data:</b> ${lastData}</p></div></div>
      ${rangeLabel ? `<div class="row"><div class="col-12"><p style="margin: 0; font-size: 13px"><b>Data Range:</b> ${rangeLabel}</p></div></div>` : ''}
      <hr style="margin: 10px 0;" />
      ${this.renderDetailPager(ship, groups, this.currentDotTrailPopupPage, suffix)}
      ${this.renderGroupBody(activeGroup)}
    `;
  }

  setupDotTrailPaginationButtons(marker, ship, data) {
    // detail perlu ikut dibaca, soalnya RPM group cuma muncul kalau detail-nya ada
    const detail = this.pointDetail[ship.massId]?.[data.timestamp]
      || ship.trailPointDetail?.[data.timestamp];
    const total = this.buildDotTrailGroups(data, detail).length;
    const go = (step) => {
      if (total < 2) return;
      this.currentDotTrailPopupPage = ((this.currentDotTrailPopupPage - 1 + step + total) % total) + 1;
      marker.setPopupContent(this.createDotTrailPopupContent(ship, data));
      this.setupDotTrailPaginationButtons(marker, ship, data);
    };
    this.setupButtonEvent(`previous-popup-button-${ship.massId}-${data.timestamp}`, () => go(-1));
    this.setupButtonEvent(`next-popup-button-${ship.massId}-${data.timestamp}`, () => go(1));
  }

  // --- Opsi Helper ---

  getPolylineMeasureOptions() {
    return {
      position: 'topleft',
      unit: 'kilometres',
      useSubunits: true,
      clearMeasurementsOnStop: false,
      showBearings: true,
      bearingTextIn: 'In',
      bearingTextOut: 'Out',
      tooltipTextFinish: 'Click to <b>finish line</b><br>',
      tooltipTextDelete: 'Press SHIFT-key and click to <b>delete point</b>',
      tooltipTextMove: 'Click and drag to <b>move point</b><br>',
      tooltipTextResume: '<br>Press CTRL-key and click to <b>resume line</b>',
      tooltipTextAdd: 'Press CTRL-key and click to <b>add point</b>',
      measureControlTitleOn: 'Turn on PolylineMeasure',
      measureControlTitleOff: 'Turn off PolylineMeasure',
      measureControlLabel: '&#8614;',
      measureControlClasses: [],
      showClearControl: true,
      clearControlTitle: 'Clear Measurements',
      clearControlLabel: '&times',
      clearControlClasses: [],
      showUnitControl: true,
      unitControlUnits: [
        'kilometres',
        'landmiles',
        'nauticalmiles',
      ],
      unitControlTitle: {
        text: 'Change Units',
        kilometres: 'kilometres',
        landmiles: 'land miles',
        nauticalmiles: 'nautical miles',
      },
      unitControlLabel: {
        metres: 'm',
        kilometres: 'km',
        feet: 'ft',
        landmiles: 'mi',
        nauticalmiles: 'nm',
      },
      unitControlClasses: [],
      tempLine: {
        color: '#00f',
        weight: 2,
      },
      fixedLine: {
        color: '#006',
        weight: 2,
      },
      arrow: {
        color: '#000',
      },
      startCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#0f0',
        fillOpacity: 1,
        radius: 3,
      },
      intermedCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#ff0',
        fillOpacity: 1,
        radius: 3,
      },
      currentCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#f0f',
        fillOpacity: 1,
        radius: 6,
      },
      endCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#f00',
        fillOpacity: 1,
        radius: 3,
      },
    };
  }

  panToShip(ship) {
    if (!this.map || !ship.lastLatLng) return;

    this.map.setView(ship.lastLatLng, 15, {
      animate: true,
      pan: {
        duration: 1,
      },
    });
  }

  // --- Landmark ---

  addMapSettingsControl() {
    if (!this.map) return;
    const MapSettingsControl = L.Control.extend({
      onAdd: () => {
        const container = L.DomUtil.create('div', 'leaflet-map-settings');
        const toggle = L.DomUtil.create('button', 'map-settings-toggle', container);
        toggle.type = 'button';
        toggle.innerHTML = '<i class="ri-settings-3-line"></i>';

        const panel = L.DomUtil.create('div', 'map-settings-panel hidden', container);
        panel.innerHTML = `
          <div class="map-settings-item map-settings-header">Base Map</div>
          <label class="map-settings-option">
            <input type="radio" name="map-base-layer" value="satellite" />
            <span>Satellite</span>
          </label>
          <label class="map-settings-option">
            <input type="radio" name="map-base-layer" value="vectorColor" />
            <span>Vector color</span>
          </label>
          <label class="map-settings-option">
            <input type="radio" name="map-base-layer" value="vectorWhite" />
            <span>Vector white</span>
          </label>
          <div class="map-settings-separator"></div>
          <div class="map-settings-item map-settings-header">Ship Icon</div>
          <label class="map-settings-option">
            <input type="radio" name="map-icon-style" value="special" />
            <span>Detailed</span>
            <img class="map-icon-sample" src="${detailedIconSample}" alt="" />
          </label>
          <label class="map-settings-option">
            <input type="radio" name="map-icon-style" value="simple" />
            <span>Simple</span>
            <img class="map-icon-sample" src="${simpleIconSample}" alt="" />
          </label>
          <div class="map-settings-separator"></div>
          <div class="map-settings-item map-settings-header">Icon Size</div>
          <div class="map-settings-size">
            <input type="range" id="map-icon-scale" min="0.6" max="1.8" step="0.1" />
            <span id="map-icon-scale-value" class="map-settings-size-value">100%</span>
          </div>
          <div class="map-settings-separator"></div>
          <label class="map-settings-switch">
            <input type="checkbox" id="map-toggle-landmarks" />
            <span>Landmarks</span>
          </label>
          <label class="map-settings-switch">
            <input type="checkbox" id="map-toggle-timezones" />
            <span>Timezone</span>
          </label>
        `;

        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        toggle.onclick = () => {
          panel.classList.toggle('hidden');
        };

        const baseInputs = panel.querySelectorAll('input[name="map-base-layer"]');
        baseInputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            this.setBaseLayer(event.target.value);
          });
        });

        const iconStyleInputs = panel.querySelectorAll('input[name="map-icon-style"]');
        iconStyleInputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            this.setIconStyle(event.target.value);
          });
        });

        const scaleInput = panel.querySelector('#map-icon-scale');
        const scaleValue = panel.querySelector('#map-icon-scale-value');
        if (scaleInput) {
          const currentScale = getMapIconScale();
          scaleInput.value = currentScale;
          if (scaleValue) {
            scaleValue.textContent = `${Math.round(currentScale * 100)}%`;
          }
          // Update the label live while dragging, but only re-render on release.
          scaleInput.addEventListener('input', (event) => {
            if (scaleValue) {
              scaleValue.textContent = `${Math.round(parseFloat(event.target.value) * 100)}%`;
            }
          });
          scaleInput.addEventListener('change', (event) => {
            this.setIconScale(parseFloat(event.target.value));
          });
        }

        const landmarksToggle = panel.querySelector('#map-toggle-landmarks');
        landmarksToggle.addEventListener('change', (event) => {
          this.toggleLandmarks(event.target.checked);
        });

        const timezonesToggle = panel.querySelector('#map-toggle-timezones');
        timezonesToggle.addEventListener('change', (event) => {
          this.toggleTimezones(event.target.checked);
        });

        this.mapSettingsPanel = panel;
        this.syncMapSettingsUI();

        return container;
      },
    });
    this.map.addControl(new MapSettingsControl({ position: 'topleft' }));
  }

  syncMapSettingsUI() {
    if (!this.mapSettingsPanel) return;
    const activeBaseInput = this.mapSettingsPanel.querySelector(`input[name="map-base-layer"][value="${this.activeBaseLayerKey}"]`);
    if (activeBaseInput) {
      activeBaseInput.checked = true;
    }
    const activeIconStyleInput = this.mapSettingsPanel.querySelector(`input[name="map-icon-style"][value="${getMapIconStyle()}"]`);
    if (activeIconStyleInput) {
      activeIconStyleInput.checked = true;
    }
    const scaleInput = this.mapSettingsPanel.querySelector('#map-icon-scale');
    if (scaleInput) {
      const currentScale = getMapIconScale();
      scaleInput.value = currentScale;
      const scaleValue = this.mapSettingsPanel.querySelector('#map-icon-scale-value');
      if (scaleValue) {
        scaleValue.textContent = `${Math.round(currentScale * 100)}%`;
      }
    }
    const landmarksToggle = this.mapSettingsPanel.querySelector('#map-toggle-landmarks');
    if (landmarksToggle) {
      landmarksToggle.checked = this.landmarksVisible;
    }
    const timezonesToggle = this.mapSettingsPanel.querySelector('#map-toggle-timezones');
    if (timezonesToggle) {
      timezonesToggle.checked = this.timezoneVisible;
    }
  }

  setBaseLayer(layerKey) {
    if (!this.map || !this.baseLayers[layerKey]) return;
    if (this.activeBaseLayer) {
      this.map.removeLayer(this.activeBaseLayer);
    }
    this.activeBaseLayer = this.baseLayers[layerKey];
    this.activeBaseLayerKey = layerKey;
    this.activeBaseLayer.addTo(this.map);
    localStorage.setItem('activeBaseLayer', layerKey);
    this.syncMapSettingsUI();
  }

  setIconStyle(style) {
    const normalized = persistMapIconStyle(style);

    // Recompute icons for the ships rendered on this map directly so maps whose
    // ships are not backed by the asset store (e.g. the FMS single-asset map)
    // update immediately too.
    this.vm.ships.forEach((ship) => {
      if (ship.shipStatus) {
        const { iconConfig, markerIconUrl } = buildIconConfig(ship, ship.shipStatus, normalized);
        ship.iconConfig = iconConfig;
        ship.markerIconUrl = markerIconUrl;
      }
      // Drop cached Leaflet icon instances so they are rebuilt from the new config.
      ship.icon = null;
      ship.markerIcon = null;
      ship.headingIcon = null;
    });

    // Keep the global asset store in sync so other store-backed maps follow.
    if (this.vm.$store) {
      this.vm.$store.dispatch('asset/applyIconSettings');
    }

    this.refreshShips();
    this.syncMapSettingsUI();
  }

  setIconScale(scale) {
    persistMapIconScale(scale);

    // Recompute icons for the ships rendered on this map directly (covers maps
    // whose ships are not backed by the asset store, e.g. the FMS map).
    this.vm.ships.forEach((ship) => {
      if (ship.shipStatus) {
        const { iconConfig, markerIconUrl } = buildIconConfig(ship, ship.shipStatus);
        ship.iconConfig = iconConfig;
        ship.markerIconUrl = markerIconUrl;
      }
      ship.icon = null;
      ship.markerIcon = null;
      ship.headingIcon = null;
    });

    // Keep the global asset store in sync so other store-backed maps follow.
    if (this.vm.$store) {
      this.vm.$store.dispatch('asset/applyIconSettings');
    }

    this.refreshShips();
    this.syncMapSettingsUI();
  }

  toggleLandmarks(forceState) {
    this.landmarksVisible = typeof forceState === 'boolean' ? forceState : !this.landmarksVisible;
    if (!this.landmarksVisible) {
      if (this.landmarksLayer) {
        this.landmarksLayer.clearLayers();
      }
      this.syncMapSettingsUI();
      return;
    }
    this.lastLandmarkBoundsKey = null;
    this.lastLandmarkBounds = null;
    const storedLandmarks = this.vm?.$store?.getters['landmark/landmarks'];
    const storedBounds = this.vm?.$store?.getters['landmark/bounds'];
    if (Array.isArray(storedLandmarks) && storedLandmarks.length) {
      this.landmarks = storedLandmarks;
      this.renderLandmarks();
    }
    if (storedBounds) {
      this.lastLandmarkBounds = L.latLngBounds(
        [storedBounds.minLatitude, storedBounds.minLongitude],
        [storedBounds.maxLatitude, storedBounds.maxLongitude],
      );
    }
    this.fetchLandmarksInView();
    this.syncMapSettingsUI();
  }

  // --- Timezone boundaries (political, lazy-loaded GeoJSON overlay) ---

  async toggleTimezones(forceState) {
    this.timezoneVisible = typeof forceState === 'boolean' ? forceState : !this.timezoneVisible;
    if (!this.map) return;

    if (!this.timezoneVisible) {
      if (this.timezoneLayer && this.map.hasLayer(this.timezoneLayer)) {
        this.map.removeLayer(this.timezoneLayer);
      }
      this.syncMapSettingsUI();
      return;
    }

    if (!this.timezoneLayer) {
      try {
        if (!this.timezoneData) {
          const response = await fetch('/data/timezones.geojson');
          this.timezoneData = await response.json();
        }
        if (!this.timezoneRenderer) {
          this.timezoneRenderer = L.canvas({ padding: 0.5 });
        }
        this.timezoneLayer = L.geoJSON(this.timezoneData, {
          renderer: this.timezoneRenderer,
          style: {
            color: '#2563eb',
            weight: 1,
            opacity: 0.6,
            fillColor: '#3b82f6',
            fillOpacity: 0.04,
          },
          onEachFeature: (feature, layer) => {
            const props = feature.properties || {};
            const label = props.utc_format || 'Timezone';
            const places = props.places ? `<br><span style="color:#6b7280">${props.places}</span>` : '';
            layer.bindTooltip(`<strong>${label}</strong>${places}`, { sticky: true });
          },
        });
      } catch (error) {
        console.warn('Failed to load timezones layer:', error);
        this.timezoneVisible = false;
        this.syncMapSettingsUI();
        return;
      }
    }

    if (!this.map.hasLayer(this.timezoneLayer)) {
      this.timezoneLayer.addTo(this.map);
    }
    this.timezoneLayer.bringToBack();
    this.syncMapSettingsUI();
  }

  handleLandmarkViewportChange() {
    if (!this.landmarksVisible) return;
    this.scheduleLandmarkFetch();
  }

  scheduleLandmarkFetch() {
    if (this.landmarkFetchTimeout) {
      clearTimeout(this.landmarkFetchTimeout);
    }
    this.landmarkFetchTimeout = setTimeout(() => {
      this.fetchLandmarksInView();
    }, 300);
  }

  async fetchLandmarksInView() {
    if (!this.map || !this.landmarksVisible) return;
    const bounds = this.map.getBounds();
    if (!bounds) return;
    const paddedBounds = bounds.pad(0.25);
    if (this.lastLandmarkBounds && this.lastLandmarkBounds.contains(paddedBounds)) {
      this.renderLandmarks();
      return;
    }
    const sw = paddedBounds.getSouthWest();
    const ne = paddedBounds.getNorthEast();
    const boundsKey = `${sw.lat.toFixed(3)}:${sw.lng.toFixed(3)}:${ne.lat.toFixed(3)}:${ne.lng.toFixed(3)}:${this.map.getZoom()}`;
    if (boundsKey === this.lastLandmarkBoundsKey) {
      this.renderLandmarks();
      return;
    }
    this.lastLandmarkBoundsKey = boundsKey;
    this.lastLandmarkBounds = paddedBounds;

    try {
      const response = await LandmarkSvc.landmarks.area({
        minLatitude: sw.lat,
        maxLatitude: ne.lat,
        minLongitude: sw.lng,
        maxLongitude: ne.lng,
      });
      const data = Array.isArray(response?.data?.data) ? response.data.data : [];
      this.landmarks = data;
      if (this.vm?.$store) {
        this.vm.$store.dispatch('landmark/setLandmarks', {
          landmarks: data,
          bounds: {
            minLatitude: sw.lat,
            maxLatitude: ne.lat,
            minLongitude: sw.lng,
            maxLongitude: ne.lng,
          },
        });
      }
      this.renderLandmarks();
    } catch (error) {
      console.warn('Failed to fetch landmarks area:', error);
    }
  }

  renderLandmarks() {
    if (!this.map || !this.landmarksVisible) return;
    if (!this.landmarksLayer) {
      this.landmarksLayer = L.layerGroup().addTo(this.map);
    }
    if (!this.landmarkIcon) {
      this.landmarkIcon = L.icon({
        iconUrl: '/marker/pinpoint.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
    }
    this.landmarksLayer.clearLayers();
    if (!this.landmarks.length) return;

    const zoom = this.map.getZoom();
    const useCluster = zoom < this.clusterZoomThreshold;
    if (!useCluster) {
      this.landmarks.forEach((landmark) => this.addLandmarkMarker(landmark));
      return;
    }

    const cellSize = this.getClusterCellSize(zoom);
    const clusters = new Map();
    this.landmarks.forEach((landmark) => {
      const lat = parseFloat(landmark.lndmLatitude);
      const lng = parseFloat(landmark.lndmLongitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return;
      const cellLat = Math.floor(lat / cellSize);
      const cellLng = Math.floor(lng / cellSize);
      const key = `${cellLat}:${cellLng}`;
      if (!clusters.has(key)) {
        clusters.set(key, {
          count: 0,
          sumLat: 0,
          sumLng: 0,
          landmarks: [],
        });
      }
      const cluster = clusters.get(key);
      cluster.count += 1;
      cluster.sumLat += lat;
      cluster.sumLng += lng;
      cluster.landmarks.push(landmark);
    });

    clusters.forEach((cluster) => {
      if (cluster.count === 1) {
        this.addLandmarkMarker(cluster.landmarks[0]);
        return;
      }
      const avgLat = cluster.sumLat / cluster.count;
      const avgLng = cluster.sumLng / cluster.count;
      const marker = L.marker([avgLat, avgLng], {
        icon: this.createClusterIcon(cluster.count),
      });
      marker.on('click', () => {
        const nextZoom = Math.min(this.map.getZoom() + 2, this.map.getMaxZoom());
        this.map.setView([avgLat, avgLng], nextZoom);
      });
      marker.addTo(this.landmarksLayer);
    });
  }

  addLandmarkMarker(landmark) {
    const lat = parseFloat(landmark.lndmLatitude);
    const lng = parseFloat(landmark.lndmLongitude);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return;
    const marker = L.marker([lat, lng], {
      icon: this.landmarkIcon,
      landmarkId: landmark.lndmId,
    });
    const name = landmark.lndmName ? this.escapeHtml(landmark.lndmName) : '-';
    const type = landmark.lndmType ? this.escapeHtml(String(landmark.lndmType).toUpperCase()) : '-';
    marker.bindPopup(`<strong>${name}</strong><br>Type: ${type}`);
    marker.addTo(this.landmarksLayer);
  }

  createClusterIcon(count) {
    return L.divIcon({
      className: 'landmark-cluster-wrapper',
      html: `<div class="landmark-cluster">${count}</div>`,
      iconSize: [36, 36],
      iconAnchor: [18, 18],
    });
  }

  getClusterCellSize(zoom) {
    if (zoom <= 3) return 6;
    if (zoom <= 5) return 3;
    if (zoom <= 7) return 1.5;
    return 1;
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}

export default MapService;
